import { PhoneBookEntry } from '../types';
import { CallButton } from './CallButton';
import { WhatsAppButton } from './WhatsAppButton';
import { StatusBadge } from './StatusBadge';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface PhoneBookTableProps {
  contacts: PhoneBookEntry[];
  showStatus?: boolean;
  showCreatedBy?: boolean;
  showEdit?: boolean;
  shivarMap?: Record<string, string>;
  creatorMap?: Record<string, string>;
  onStatusChange?: (id: string, status: 'UNDER_REVIEW' | 'APPROVED' | 'BLOCKED') => void;
}

export const PhoneBookTable = ({ contacts, showStatus, showCreatedBy, showEdit, shivarMap, creatorMap, onStatusChange }: PhoneBookTableProps) => {
  const { role } = useAuth();
  const navigate = useNavigate();
  const canEdit = role === 'EMPLOYEE' || role === 'ADMIN';
  const showEditBtn = showEdit ?? canEdit;
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium uppercase text-gray-500">Marathi Name</th>
            <th className="px-4 py-3 text-left text-xs font-medium uppercase text-gray-500">Name</th>
            <th className="px-4 py-3 text-left text-xs font-medium uppercase text-gray-500">Shivar</th>
            <th className="px-4 py-3 text-left text-xs font-medium uppercase text-gray-500">Village</th>
            {showCreatedBy && <th className="px-4 py-3 text-left text-xs font-medium uppercase text-gray-500">Added By</th>}
            {showStatus && <th className="px-4 py-3 text-left text-xs font-medium uppercase text-gray-500">Status</th>}
            <th className="px-4 py-3 text-right text-xs font-medium uppercase text-gray-500">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {contacts.map((contact) => (
            <tr key={contact.id}>
              <td className="px-4 py-3 text-sm font-medium text-blue-800" lang="mr">
                {contact.marathi_name}
              </td>
              <td className="px-4 py-3 text-sm text-gray-900">{contact.name}</td>
              <td className="px-4 py-3 text-sm text-gray-700">
                {contact.shivar ? shivarMap?.[contact.shivar] ?? contact.shivar : '-'}
              </td>
              <td className="px-4 py-3 text-sm text-gray-700">{contact.village ?? '-'}</td>
              {showCreatedBy && (
                <td className="px-4 py-3 text-sm text-gray-700">
                  {contact.created_by ? (creatorMap?.[contact.created_by] ?? '-') : '-'}
                </td>
              )}
              {showStatus && (
                <td className="px-4 py-3">
                  {onStatusChange ? (
                    <select
                      value={contact.status}
                      onChange={(e) => onStatusChange(contact.id, e.target.value as 'UNDER_REVIEW' | 'APPROVED' | 'BLOCKED')}
                      className="rounded border border-gray-300 px-2 py-1 text-xs"
                    >
                      <option value="UNDER_REVIEW">Under Review</option>
                      <option value="APPROVED">Approved</option>
                      <option value="BLOCKED">Blocked</option>
                    </select>
                  ) : (
                    <StatusBadge status={contact.status} />
                  )}
                </td>
              )}
              <td className="px-4 py-3 text-right">
                <div className="flex justify-end gap-2">
                  <CallButton contact={contact} size="sm" />
                  <WhatsAppButton contact={contact} size="sm" />
                  {showEditBtn && (
                    <button
                      onClick={() => navigate(`/edit-contact/${contact.id}`)}
                      className="rounded bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700 hover:bg-blue-200"
                    >
                      Edit
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
